import clarity, { consent, init } from './clarity'

export { consent, init }
export default clarity
